import { Component, EventEmitter, Optional } from '@angular/core';
import { FormBuilder, Validators, ControlContainer, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { COBVerifyOtpFormHelper, COBVerifyOtpFormState } from './cob-verify-otp-form.helper';
import { BaseFpxFormComponent, ValidatorService } from '@fpx/core';
import { VerifyotpService } from '../verifyotp-service/verifyotp.service';
import { Verifyotp } from '../verifyotp-service/verifyotp.model';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-cob-verify-otp-form',
  templateUrl: './cob-verify-otp-form.component.html',
  styleUrls: ['./cob-verify-otp-form.component.scss'],
  providers: [
    COBVerifyOtpFormHelper, VerifyotpService
  ]
})

export class COBVerifyOtpFormComponent extends BaseFpxFormComponent<COBVerifyOtpFormHelper, COBVerifyOtpFormState> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public cOBVerifyOtpFormHelper: COBVerifyOtpFormHelper,
    public verifyotpService: VerifyotpService,
    private validatorService: ValidatorService,
    private _matDialogRef: MatDialogRef<COBVerifyOtpFormComponent>

  ) {
    super(formBuilder, router, controlContainer, cOBVerifyOtpFormHelper);
  }

  protected override doPreInit(): void {
    this.addFormControl('otp', '', [Validators.required], [], 'change');
    this.setDataService(this.verifyotpService);
    console.log(this._matDialogRef);
  }

}
